import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=5ddb171c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=5ddb171c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddb171c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ddb171c')) {
      api.createRecord('5ddb171c', component.options)
    } else {
      api.reload('5ddb171c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=5ddb171c&scoped=true&", function () {
      api.rerender('5ddb171c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-269j70cbrGQEr/JS/comp/GuestBox.vue"
export default component.exports